/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ModalDialog = ({ location, zIndex, children }) => {
    
    return (
        <div
            className="modal"
            style={{
                top: location.top,
                left: location.left,
                zIndex,
                position: "absolute",
                marginTop: "12px",
            }}
        >
            {children}
        </div>
    );
};

export default ModalDialog;
